<div class="case-feature-preview">
  <div class="case-feature-preview__body">
    <div *ngIf="isLoading(); else objectsContent" class="case-feature-preview__loader">
      <ui-preloader [color]="preloaderColor"></ui-preloader>
    </div>

    <ng-template #objectsContent>
      <div *ngIf="objectCards().length; else noObjects" class="case-feature-object-grid">
        <div *ngFor="let object of objectCards()" class="case-feature-object">
          <div class="case-feature-object__image">
            <img [appAuthSrc]="object.objectUrl" [alt]="object.archiveName" />
          </div>
          <div class="case-feature-object__name" [title]="object.archiveName">
            {{ object.archiveName }}
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #noObjects>
      <div class="case-feature-preview__empty">
        <span class="case-feature-preview__empty-icon ui-icon-search"></span>
        <div>{{ 'CASES.OBJECTS.NO_DATA.TITLE' | translate }}</div>
      </div>
    </ng-template>
  </div>
</div>
